export default {"src":"/_next/static/media/icBTC.63ca3334.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};